import { useMediaQuery } from './use-media-query';

const MOBILE_BREAKPOINT = 768;

/**
 * A convenience hook that returns whether the viewport is mobile-sized.
 *
 * Uses the standard mobile breakpoint of 768px (max-width: 767px).
 *
 * @returns `true` if viewport width is less than 768px, `false` otherwise
 *
 * @example
 * ```tsx
 * const isMobile = useIsMobile();
 *
 * return isMobile ? <MobileNav /> : <DesktopNav />;
 * ```
 */
export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
}
